
import React from "react";
import { Link } from "react-router-dom";
import "./Main.css";
import realburger from "../assets/real-burger.png";

function Main() {
  return (
    <section className="hero-section">
      <div className="hero-content">
        <h1 className="hero-title">
          Gourmet. The way <br />
          <span>burgers should be.</span>
        </h1>
        <p className="hero-subtitle">
          Experience the art of burger making with our locally sourced, 
          hand-crafted masterpieces. Every bite is a journey of flavor.
        </p>
        <Link to="/explore" className="button-gourmet">
          Order Online
        </Link>
      </div>

      <div className="hero-image-container">
        <img
          className="hero-image"
          src={realburger}
          alt="Premium Gourmet Burger"
        />
        {/* Subtle decorative elements to match the reference "salt/pepper" look */}
        <div className="deco-dots"></div>
      </div>
    </section>
  );
}

export default Main;
